import { gql } from '@apollo/client';

export const ME_CONFIRMATION_NUMBER = gql`
  query ME_CONFIRMATION_NUMBER {
    me {
      confirmationNumber
    }
  }
`;

export const ME_APPT_AND_GUEST_CODE = gql`
  query ME_APPT_AND_GUEST_CODE {
    me {
      id
      firstName
      lastName
      guest
      confirmationNumber
      event {
        appointmentEvents {
          id
          apptEventCode
          apptEventType
          status
          readOnly
        }
        start
        end
      }
      permissions {
        roles {
          boothStaff
        }
      }
    }
  }
`;

export const ME_CONSENT_EXHIBITOR_ANSWER = gql`
  # Used to update consent Answer when an answer call is successful
  query ME_CONSENT_EXHIBITOR_ANSWER {
    me {
      id
      exhibitorConsentAnswer {
        attendeeId
        questionId
        questionText
        answerId
        choice {
          text
          id
        }
        locale
        lastModifiedDate
      }
    }
  }
`;

export const ME_PROFILE_PICTURE_FRAGMENT = gql`
  # Used to optimistically update local cache when updating profile picture
  fragment ProfilePicture on User {
    profilePicture
  }
`;

// Todo: HUB-84906 Remove during old profile cleanup
export const ME_PROFILE_PICTURE = gql`
  # Used to optimistically update local cache when updating profile picture
  query ME_PROFILE_PICTURE($locale: String) {
    me {
      id
      profilePicture
      firstName
      lastName
      address(locale: $locale) {
        city
        region
        regionCode
        country
        countryCode
      }
      headline
      bio
      pronouns
      facebookUrl
      linkedInUrl
      twitterUrl
      websiteUrl
      prefix
      designation
      title
      company
    }
  }
`;

export const ME_ADMISSION_ITEM = gql`
  # Used to optimistically update local cache when upgrading admission item
  query ME_ADMISSION_ITEM {
    me {
      admissionItem {
        id
        name
      }
    }
  }
`;

export const GET_LOCALIZED_LOCATIONS = gql`
  query getLocalizedLocations($locale: String!, $countryCode: String) {
    getLocalizedLocations(locale: $locale, countryCode: $countryCode) {
      locationCode
      locationTranslation
      locationName
    }
  }
`;
